import { ChainId, Token } from '../../sdk'

export const MST: { [chainId: number]: Token } = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0x568524DA340579887db50Ecf602Cd1BA8451b243',
    18,
    'MST',
    'Meridian Stability Token',
  ),
}

export const WTLOS = new Token(
  ChainId.MAINNET,
  '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
  18,
  'WTLOS',
  'Wrapped TLOS',
)
export const USDC = new Token(ChainId.MAINNET, '0x8D97Cea50351Fb4329d591682b148D43a0C3611b', 6, 'USD Coin', 'USDC')
export const USDT = new Token(ChainId.MAINNET, '0x975Ed13fa16857E83e7C493C7741D556eaaD4A3f', 6, 'Tether Stable Coin', 'USDT')
export const USDM = new Token(ChainId.MAINNET, '0x8f7D64ea96D729EF24a0F30b4526D47b80d877B9', 18, 'USDM', 'USDM')
export const ETH = new Token(ChainId.MAINNET, '0xA0fB8cd450c8Fd3a11901876cD5f17eB47C6bc50', 18, 'Ethereum', 'ETH')
export const BTC = new Token(ChainId.MAINNET, '0x7627b27594bc71e6Ab0fCE755aE8931EB1E12DAC', 8, 'Bitcoin', 'BTC.b')
export const STLOS = new Token(ChainId.MAINNET, '0xB4B01216a5Bc8F1C8A33CD990A1239030E60C905', 18, 'Staked TLOS', 'STLOS')



const tokens = {
  tlos: {
    symbol: 'TLOS',
    projectLink: 'https://www.telos.net',
  },
  masterRewardToken: {
    symbol: 'USDM',
    address: {
      40: '0x8f7D64ea96D729EF24a0F30b4526D47b80d877B9',
    },
    decimals: 18,
    projectLink: 'https://meridianfinance.net',
  },
  mst: {
    symbol: 'MST',
    address: {
      40: '0x568524DA340579887db50Ecf602Cd1BA8451b243',
    },
    decimals: 18,
    projectLink: 'https://meridianfinance.net',
  },
  slush: {
    symbol: 'SLUSH',
    address: {
      40: '0xaC45EDe2098bc989Dfe0798B4630872006e24c3f',
    },
    decimals: 18,
    projectLink: 'https://www.swapsicle.io/',
  },
  rf: {
    symbol: 'RF',
    address: {
      40: '0xb99C43d3bce4c8Ad9B95a4A178B04a7391b2a6EB',
    },
    decimals: 18,
    projectLink: 'https://reactorfusion.xyz/',
  },
  usdm: {
    symbol: 'USDM',
    address: {
      40: '0x8f7D64ea96D729EF24a0F30b4526D47b80d877B9',
    },
    decimals: 18,
    projectLink: 'https://meridianfinance.net',
  },
  wtlos: {
    symbol: 'wTLOS',
    address: {
      40: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
    },
    decimals: 18,
    projectLink: 'https://www.telos.net',
  },
  stlos: {
    symbol: 'STLOS',  
    address: {
      40: '0xB4B01216a5Bc8F1C8A33CD990A1239030E60C905',
    },
    decimals: 18,
    projectLink: 'https://www.telos.net',
  },
  usdt: { 
    symbol: 'USDT', 
    address: {
      40: '0x975Ed13fa16857E83e7C493C7741D556eaaD4A3f',
    },
    decimals: 6,
    projectLink: 'https://meridianfinance.net',
  },
  usdc: {
    symbol: 'USDC', 
    address: {
      40: '0x8D97Cea50351Fb4329d591682b148D43a0C3611b',
    },
    decimals: 6,
    projectLink: 'https://meridianfinance.net',
  },
  eth: {
    symbol: 'ETH',
    address: {
      40: '0xA0fB8cd450c8Fd3a11901876cD5f17eB47C6bc50',
    },
    decimals: 18,
    projectLink: 'https://meridianfinance.net',
  },  
  btc: {
    symbol: 'BTC.b',
    address: {
      40: '0x7627b27594bc71e6Ab0fCE755aE8931EB1E12DAC',
    },
    decimals: 8,
    projectLink: 'https://meridianfinance.net',
  }

}

export default tokens